import React from 'react';
import {Link} from 'react-router-dom';

import DateSince from '../../../../components/Date';
import TagList from '../../../../components/TagList';
import Avatar from '../../../../components/Avatar';
import Views from '../../../../components/Views';
import createLink from "../../../../../libs/createLink";
import Dotdotdot from "react-dotdotdot";
import {genererViews, isNoFollowArticle} from "../../../../../libs/helper";

const BookHistoire = (props) => {
    let content = props.excerpt || "";
    if (content.length > 300) {
        content = content.substring(0, 300) + '...';
    }
    let hasOwner = props.owner !== null && props.owner._id;
    let relLink = {};
    if(props.content !== null){
        if(props.kind === "Article"){
            relLink = isNoFollowArticle(props.content) ? { rel: "nofollow" } : {};
        }
    }

    return (
        <div className="book-histoire">
            <div className="header">
                {hasOwner ? (
                    <Link to={createLink("userProfile", props.owner)}>
                        <Avatar className="user-thumb"
                                avatar={props.owner.profile.avatar}
                                gender={props.owner.profile.gender}/>
                    </Link>
                ) : (
                    <Avatar className="user-thumb" gender={"guest"}/>
                )}

                <div className="wrapper link">
                    <div className="user">
                        {hasOwner ? (
                            <Link to={createLink("userProfile", props.owner)}>{props.owner.username}</Link>
                        ) : (
                            <span>{props.authorName}</span>
                        )}
                    </div>
                    <div className="date">
                        <DateSince
                            date={props.createdAt}
                            prefix={true}
                            currentFormat={true}
                        />
                    </div>
                </div>
                <Views value={(props.content && props.content.count && genererViews(props.content.count.view)) || 0}/>
            </div>
            <div className="body">
                {props.content !== null && props.content._id && (
                    <Link
                        to={props.kind === "Topic" ? createLink("forumTopic", {category : {slug : props.content.forum.slug, _id : props.content.forum._id}, topic : {_id : props.content._id, slug : props.content.slug}}) : createLink('article', {...props.owner, article : {_id : props.content._id, slug : props.content.slug}})}
                        className="title" {...relLink}>
                        <Dotdotdot tagName="h4" clamp={2} useNativeClamp={false}>
                            {props.title}
                        </Dotdotdot>
                    </Link>
                )}

                <div className="content">{content}</div>
            </div>
            {props.tags.length >= 1 && (<div className="tagsList">
                <TagList mediaType={props.type} tags={Array.isArray(props.tags) && props.tags.slice(0, 5)} type={"tagStory"} owner={props.owner}/>
            </div>)}
        </div>
    )
};

BookHistoire.defaultProps = {
    _id: 0,
    title: "",
    content: {},
    type: "",
    createdAt: 0,
    tags: [],
    owner: {
        _id: 0,
        slug: "",
        username: "",
        profile: {
            avatar: "",
            gender: ""
        }
    },
    count: {
        comment: 0,
        like: 0,
        view: 0
    }

};

export default BookHistoire;
